export const AUDIT_SYSTEM_USER = 'service-account-newton-services';
export const AUDIT_PATH = 'audit';
